import React from 'react';

export interface IOptionItem {
    label: string;
    value: string | number;
}
export interface ISelectList {
    options: IOptionItem[];
    callBack: (seelectedValue: string) => void;
    ariaLabel?: string;
    selectedIndex?: number;
    customClassName?: string;
    initialLabel?: string;
    /**
     * The selected value. Pass this when the choice comes from somewhere other than this
     * menu itself - the environment lives in the url, for instance, and without this prop
     * the menu keeps showing its placeholder afterwards.
     */
    value?: string | number;
}

export const Select = ({
    options,
    callBack,
    ariaLabel,
    selectedIndex,
    customClassName,
    initialLabel,
    value,
}: ISelectList) => {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        callBack(event.target.value);
    };

    // Without value this menu stays uncontrolled, the way the rest of the app uses it.
    const controlled =
        value !== undefined ? { value } : { defaultValue: undefined };

    return (
        <select
            className={`form-select ${customClassName ?? ''}`}
            aria-label={ariaLabel}
            onChange={handleChange}
            {...controlled}
        >
            {initialLabel && <option value="">{initialLabel}</option>}

            {options.map((x, index) => (
                <option key={index} value={x.value}>
                    {x.label}
                </option>
            ))}
        </select>
    );
};
